import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { industries } from "@/data/industries";

export default function IndustriesIndex() {
  return (
    <div>
      <section className="pt-16 pb-16 md:pt-24 md:pb-20 border-b border-[#27272a] relative overflow-hidden">
        <div className="absolute inset-0 radial-fade" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className="eyebrow mb-6">
              <span className="gold-line" />
              Industries
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              Built for professionals <br />
              who <span className="text-[#C8A24B]">win on trust.</span>
            </h1>
            <p className="mt-8 text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              Every industry has its own trust economy. The presence system
              underneath needs to reflect it.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((ind) => {
            const Icon = ind.icon;
            return (
              <Link
                key={ind.slug}
                to={`/industries/${ind.slug}`}
                data-testid={`industries-index-card-${ind.slug}`}
                className="group border border-[#27272a] hover:border-[#C8A24B]/50 bg-[#0e0e0e] p-8 rounded-sm transition-all duration-500 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 border border-[#27272a] flex items-center justify-center group-hover:border-[#C8A24B] transition-colors">
                    <Icon size={20} className="text-[#C8A24B]" strokeWidth={1.4} />
                  </div>
                  <ArrowUpRight size={18} className="text-[#52525b] group-hover:text-[#C8A24B]" />
                </div>
                <h3 className="font-heading text-xl text-white mb-2">{ind.title}</h3>
                <p className="text-sm text-[#a1a1aa] leading-relaxed">{ind.lead}</p>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
